export default __webpack_public_path__ + "static/media/C2_30_x_40_Blanc.2c09e503.jpg";